import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ClickAwayListener } from '@mui/material';
import Button from 'blocks/Button';
import Loading from 'components/Loading';
import { useEffect, useRef, useState } from 'react';
import ajax from 'utils/ajax';
import TextField from '../TextField';
import * as S from './SelectField.styles';
import { MenuInterface, SelectFieldProps } from './selectField.interface';

const SelectField = ({
  id = '',
  control,
  menu,
  onChange,
  onSelect,
  label,
  disabled,
  apiUrl = '',
  error,
  placeholder,
  requestOnce,
  autoCompelete,
  multiSelect,
  defaultValue = null,
  firstItemAsDefault = false,
  required = false,
}: SelectFieldProps) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuList, setMenuList] = useState(menu || []);
  const [selectedItems, setSelectedItems] = useState<Array<MenuInterface>>([]);
  const [filteredMenuList, setFilteredMenuList] = useState(menu || []);
  const requestOnceRef = useRef(false);

  const [selected, setSelected] = useState<MenuInterface>({ title: '', value: null });

  useEffect(() => {
    if (show && apiUrl && !requestOnceRef.current) {
      getMenuList();
      if (requestOnce) requestOnceRef.current = true;
    }
  }, [show]);
  useEffect(() => {
    setMenuList(menu || []);
    setFilteredMenuList(menu || []);
  }, [menu]);

  useEffect(() => {
    if (menuList) {
      if (multiSelect) {
        const arr: any = defaultValue
          ? menuList.filter((e, index) => {
            return defaultValue.includes(e.value);
          })
          : [];
        setSelectedItems(arr);
      } else {
        var value = defaultValue
          ? menuList.find((e) => e.value === defaultValue)
          : firstItemAsDefault
            ? menuList[0]
            : null;
        setSelected(value ?? { title: '', value: null });
      }
    } else if (!defaultValue && !firstItemAsDefault) {
      if (multiSelect) {
        setSelectedItems([]);
      } else {
        setSelected({ title: '', value: null });
      }
    }
  }, [defaultValue, firstItemAsDefault]);

  useEffect(() => { }, [selectedItems]);

  const handleClickItem = (item: MenuInterface) => {
    const selectedItemArray = [...selectedItems];
    if (multiSelect) {
      if (!selectedItemArray.filter((selecteItem: MenuInterface) => selecteItem.title === item.title).length) {
        selectedItemArray.push(item);
      }
      setSelectedItems(selectedItemArray);
    } else {
      setSelected(item);
    }
    if (onSelect) {
      onSelect(multiSelect ? selectedItemArray : item.objectValue);
    }

    setShow(false);

    onChange(item.value);
  };

  const getMenuList = async () => {
    setLoading(true);

    const res = await ajax<Array<{ title: string; value: string }>>({
      url: apiUrl || '',
      method: 'GET',
    }).finally(() => setLoading(false));

    if (!res) return;

    setMenuList(res);
    setFilteredMenuList(res);
  };

  const onFilter = (e: any) => {
    const value = e.target.value;
    if (!value) handleClickItem({ title: '', value: null });
    setFilteredMenuList(
      value ? menuList.filter((item) => item.title.toLowerCase().includes(value.toLowerCase())) : menuList
    );
  };

  const handleRemove = (item: MenuInterface) => {
    const selectedItemsArray = selectedItems.filter((selectedItem) => selectedItem.title !== item.title);

    if (onSelect) onSelect(selectedItemsArray);

    setSelectedItems(selectedItemsArray);
  };

  return (
    <ClickAwayListener onClickAway={() => setShow(false)}>
      <S.Wrapper>
        <TextField
          id={id}
          // control={control}
          readonly={!autoCompelete}
          onClick={() => setShow(true)}
          label={label}
          iconEnd={<ArrowDropDownIcon />}
          disabled={disabled}
          error={error}
          placeholder={placeholder}
          onChange={onFilter}
          chips={selectedItems}
          onRemove={handleRemove}
          defaultValue={selected?.title}
          required={required}
        />
        <S.Dropdown $active={show}>
          {loading ? (
            <S.DropdownLoading as={Loading} size="small" />
          ) : (
            filteredMenuList.map((item) => (
              <S.DropdownItem as={Button} color="text-button" onClick={() => handleClickItem(item)} key={item.title}>
                {item.title}
              </S.DropdownItem>
            ))
          )}
        </S.Dropdown>
      </S.Wrapper>
    </ClickAwayListener>
  );
};

export default SelectField;

// const SelectField = ({
//   id = '',
//   control,
//   menu,
//   onChange,
//   onSelect,
//   label,
//   disabled,
//   apiUrl = '',
//   error,
//   placeholder,
//   requestOnce,
//   autoCompelete,
//   multiSelect,
//   defaultValue = '',
//   firstItemAsDefault = false,
//   required = false,
// }: SelectFieldProps) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [menuList, setMenuList] = useState(menu || []);
//   const [selectedItems, setSelectedItems] = useState<Array<SelectOptionInterface>>([]);
//   const [filteredMenuList, setFilteredMenuList] = useState(menu || []);
//   const requestOnceRef = useRef(false);

//   const [selected, setSelected] = useState<SelectOptionInterface>({ title: '', value: '' });
//   useEffect(() => {
//     if (show && apiUrl && !requestOnceRef.current) {
//       getMenuList();
//       if (requestOnce) requestOnceRef.current = true;
//     }
//   }, [show]);

//   // useEffect(() => {
//   //   if (menuList) {
//   //     const value = defaultValue
//   //       ? menuList.find((e) => e.value === defaultValue) || { title: '', value: '' }
//   //       : firstItemAsDefault
//   //       ? menuList[0]
//   //       : { title: '', value: '' };
//   //     setSelected(value);
//   //   } else if (!defaultValue && !firstItemAsDefault) {
//   //     setSelected({ title: '', value: '' });
//   //   }
//   // }, [defaultValue, firstItemAsDefault, menuList]);
//   useEffect(() => {
//     if (menuList) {
//       if (multiSelect) {
//         const arr: any = defaultValue
//           ? menuList.filter((e, index) => {
//               return defaultValue.includes(e.value);
//             })
//           : [];
//         setSelectedItems(arr);
//       } else {
//         var value = defaultValue
//           ? menuList.find((e) => e.value === defaultValue)
//           : firstItemAsDefault
//           ? menuList[0]
//           : null;
//         setSelected(value ?? { title: '', value: '' });
//       }
//     } else if (!defaultValue && !firstItemAsDefault) {
//       if (multiSelect) {
//         setSelectedItems([]);
//       } else {
//         setSelected({ title: '', value: '' });
//       }
//     }
//   }, [defaultValue, firstItemAsDefault, menuList]);

//   useEffect(() => {}, [selectedItems]);

//   const handleClickItem = (item: SelectOptionInterface) => {
//     setShow(false);
//     setSelected(item);

//     onChange && onChange(item.value);

//     onSelect && onSelect(item);
//     const selectedItemArray = [...selectedItems];

//     if (multiSelect) {
//       if (!selectedItemArray.filter((selecteItem: SelectOptionInterface) => selecteItem.title === item.title).length) {
//         selectedItemArray.push(item);
//       }
//     }

//     // if (!multiSelect) onChange(item.value);

//     if (onSelect) {
//       onSelect(multiSelect ? selectedItemArray : item.objectValue);
//     }

//     setSelectedItems(selectedItemArray);
//   };

//   const getMenuList = async () => {
//     setLoading(true);

//     const res = await ajax<Array<{ title: string; value: string }>>({
//       url: apiUrl || '',
//       method: 'GET',
//     }).finally(() => setLoading(false));

//     if (!res) return;

//     setMenuList(res);
//     setFilteredMenuList(res);
//   };

//   const onFilter = (e: any) => {
//     const value = e.target.value;
//     if (!value) handleClickItem({ title: '', value: '' });
//     setFilteredMenuList(
//       value ? menuList.filter((item) => item.title.toLowerCase().includes(value.toLowerCase())) : menuList
//     );
//   };

//   const handleRemove = (item: SelectOptionInterface) => {
//     const selectedItemsArray = selectedItems.filter((selectedItem) => selectedItem.title !== item.title);

//     if (onSelect) onSelect(selectedItemsArray);

//     setSelectedItems(selectedItemsArray);
//   };

//   return (
//     <ClickAwayListener onClickAway={() => setShow(false)}>
//       <S.Wrapper>
//         <TextField
//           id={id}
//           // control={control}
//           readonly={!autoCompelete}
//           onClick={() => !disabled && setShow(true)}
//           label={label}
//           iconEnd={<ArrowDropDownIcon />}
//           disabled={disabled}
//           error={error}
//           placeholder={placeholder}
//           onChange={onFilter}
//           chips={selectedItems}
//           onRemove={handleRemove}
//           defaultValue={selected?.title}
//           required={required}
//         />
//         <S.Dropdown $active={show}>
//           {loading ? (
//             <S.DropdownLoading as={Loading} size="small" />
//           ) : (
//             filteredMenuList.map((item) => (
//               <S.DropdownItem as={Button} color="text-button" onClick={() => handleClickItem(item)} key={item.title}>
//                 {item.title}
//               </S.DropdownItem>
//             ))
//           )}
//         </S.Dropdown>
//       </S.Wrapper>
//     </ClickAwayListener>
//   );
// };

// export default SelectField;
